module.exports = __webpack_public_path__ + "static/img/KathLoughnan.3bf2a9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KathLoughnan.jpg
// module id = TAqC
// module chunks = 0